import type { SubscribeToEventOptions } from '../store'

/**
 * Collects per-event subscriptions for a `subscribeToXxxEvents()`
 * composable: returns an adder that subscribes only when the handler is
 * defined and pushes the unsubscribe function onto the shared list.
 * `P` is whatever payload shape the event family uses (wrapped in
 * `SignalRReceiveEvent` or not); subscribe functions that take no
 * per-event options simply ignore the third argument.
 */
export function createSubscriptionAdder(unsubscribeFunctions: (() => void)[]) {
  return <P>(
    handler: ((payload: P) => void) | undefined,
    subscribeFn: (
      cb: (payload: P) => void,
      options?: SubscribeToEventOptions
    ) => () => void,
    eventOptions?: SubscribeToEventOptions
  ) => {
    if (handler) {
      unsubscribeFunctions.push(subscribeFn(handler, eventOptions))
    }
  }
}
